module.exports = __webpack_public_path__ + "img/40_38_049_600.7c109896.jpg";